// Chip-checkbox reutilizable para selecciones múltiples (extraído de
// PestanaEvaluacion.tsx, usado también por el multiselect de Áreas de
// práctica en la ficha de Usuario).
export function SelectorMultiple({
  opciones,
  seleccionados,
  onCambiar,
  vacio,
}: {
  opciones: { id: string; etiqueta: string }[];
  seleccionados: Set<string>;
  onCambiar: (id: string) => void;
  vacio?: string;
}) {
  return (
    <div className="flex flex-wrap gap-3">
      {opciones.map((o) => (
        <label
          key={o.id}
          className="flex items-center gap-2 rounded-lg border border-borde px-3 py-1.5 text-sm text-texto"
        >
          <input
            type="checkbox"
            checked={seleccionados.has(o.id)}
            onChange={() => onCambiar(o.id)}
            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2"
          />
          {o.etiqueta}
        </label>
      ))}
      {opciones.length === 0 && (
        <span className="text-sm text-texto-secundario">{vacio ?? "No hay opciones disponibles."}</span>
      )}
    </div>
  );
}
